import { apiClient } from '../../../../lib/api-client';
import { CountertopUniversity } from "../types/CountertopUniversity";

export async function apiGetCountertopUniversity(
    parentCompanyID: number | null, 
    profileID: number | null
): Promise<CountertopUniversity> 
{
    try {
        return await apiClient.get("countertop-university",
            {
                params: {
                    parentCompanyID: parentCompanyID,
                    profileID: profileID
                }
            });
    }
    catch (error: any) {
        console.log(error);
        return new Promise((resolve, reject) => { return reject(error); });
    }
};